/* unplugin-vue-components disabled */import script from "./group.vue?vue&type=script&setup=true&lang=ts"
export * from "./group.vue?vue&type=script&setup=true&lang=ts"

import "./group.vue?vue&type=style&index=0&id=78fee801&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fee801"]])

export default __exports__